var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClearIcon = function SvgClearIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#F1EDFD",
    rx: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C34CD",
    fillRule: "evenodd",
    d: "M9.97 9.97a.75.75 0 0 1 1.06 0L15 13.94l3.97-3.97a.75.75 0 1 1 1.06 1.06L16.06 15l3.97 3.97a.75.75 0 1 1-1.06 1.06L15 16.06l-3.97 3.97a.75.75 0 1 1-1.06-1.06L13.94 15l-3.97-3.97a.75.75 0 0 1 0-1.06",
    clipRule: "evenodd"
  })));
};
export default SvgClearIcon;